module.exports = __webpack_public_path__ + "static/media/internet-of-things10.9ee81072.jpg";